import React from 'react';
export const OnchainId = ({
  firstName,
  lastName,
  identityAddress,
  style = {}
}) => {
  console.error(`
! This component may be depricated in following Tokeny-ui versions

The react component OnChainID is now named EthWallet.
You only need to rename the component in your app to EthWallet
`);
  return /*#__PURE__*/React.createElement("div", {
    className: "onchainid",
    style: { ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "onchainid__status"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "onchainid__username"
  }, firstName, " ", lastName), /*#__PURE__*/React.createElement("span", {
    className: "onchainid__wallet"
  }, identityAddress)));
};